(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
        this.updatePinnedHeader();
      });
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.headerSpacer = document.createElement('div');
        this.headerSpacer.className = 'cos-header-spacer';
        this.headerSpacer.dataset.desktopOverlay = this.dataset.desktopOverlay;
        this.headerSpacer.dataset.mobileOverlay = this.dataset.mobileOverlay;
        this.headerSpacer.setAttribute('aria-hidden', 'true');
        this.header.before(this.headerSpacer);
        this.announcementSection = document.querySelector('.cos-announcement-section');
        this.heroBanner = document.querySelector(this.dataset.heroSelector || 'cos-home-banner');
        this.layoutObserver = new ResizeObserver(() => this.updatePinnedHeader());
        if (this.announcementSection) this.layoutObserver.observe(this.announcementSection);
        if (this.heroBanner) this.layoutObserver.observe(this.heroBanner);
        this.onLayoutChange = () => {
          this.heroBanner = document.querySelector(this.dataset.heroSelector || 'cos-home-banner');
          if (this.heroBanner) this.layoutObserver.observe(this.heroBanner);
          this.updatePinnedHeader();
        };
        window.addEventListener('resize', this.onLayoutChange);
        window.addEventListener('load', this.onLayoutChange);
        document.addEventListener('shopify:section:load', this.onLayoutChange);
        this.updatePinnedHeader();
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.headerSpacer?.style.setProperty('--cos-spacer-height', `${this.header.offsetHeight}px`);
    }

    updatePinnedHeader() {
      if (!this.headerSpacer) return;
      const announcementHeight = this.announcementSection?.getBoundingClientRect().height || 0;
      this.header.style.setProperty('--cos-announcement-height', `${announcementHeight}px`);
      this.header.classList.add('cos-header-pinned');
      this.headerSpacer.classList.add('cos-header-spacer--active');
      this.headerSpacer.style.setProperty('--cos-spacer-height', `${this.header.offsetHeight}px`);
      this.heroBanner = document.querySelector(this.dataset.heroSelector || 'cos-home-banner');
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const overlayEnabled = desktop ? this.dataset.desktopOverlay === 'true' : this.dataset.mobileOverlay === 'true';
      const overHero = overlayEnabled
        && this.heroBanner
        && this.heroBanner.getBoundingClientRect().bottom > announcementHeight + this.header.offsetHeight;
      this.header.classList.toggle('cos-header-over-hero', Boolean(overHero));
    }

    disconnectedCallback() {
      this.headerSpacer?.remove();
      this.header.classList.remove('cos-header-pinned', 'cos-header-over-hero');
      this.layoutObserver?.disconnect();
      window.removeEventListener('resize', this.onLayoutChange);
      window.removeEventListener('load', this.onLayoutChange);
      document.removeEventListener('shopify:section:load', this.onLayoutChange);
      this.headerResizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerIsAlwaysSticky) {
        this.updatePinnedHeader();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
